import { ACTIONS } from 'actions/cue-analytics';
import { CONFIG } from 'constants/logger/cueAnalytics';
import { bakeAnalyticsMeta } from '@cuemath/intel';

const initialState = {
  data: {},
  user_identify: {},
  config: CONFIG,
  timestamp: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === ACTIONS.SET_CUE_ANALYTICS_DATA) {
    return {
      ...state,
      ...payload,
    };
  }

  if (type === ACTIONS.USER_IDENTIFICATION_CUE_ANALYTICS) {
    return {
      ...state,
      ...payload,
    };
  }

  return state;
}

export const getAnalyticsMeta = state => {
  const { user_identify: userIdentify = {}, config } = state || {};

  return bakeAnalyticsMeta(userIdentify, config);
};
